'use es6';

// Taken from UIComponents
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "transitioning"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TwoWayTransition from 'UIComponents/transitions/TwoWayTransition';
import { PANEL_TRANSITION_TIMING } from 'HubStyleTokens/times';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const slideAxis = align => align === 'top' || align === 'bottom' ? 'translateY' : 'translateX';
const slideDirection = align => align === 'bottom' || align === 'right' ? '(100%)' : '(-100%)';
const MobilePanelTransitionWrapper = styled(_ref => {
  let {
      open,
      transitioning
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TwoWayTransition.PlainWrapper, Object.assign({
    "data-component-name": "UIPanel",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "MobilePanelTransition__MobilePanelTransitionWrapper",
  componentId: "sc-19jqz8v-0"
})(["transition-property:", ";transition-duration:", "ms;transform:", ";position:fixed;top:0;bottom:0;z-index:", ";width:100%;"], ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', ({
  duration
}) => duration, ({
  open,
  align
}) => {
  if (open) return `${slideAxis(align)}(0%)`;
  return `${slideAxis(align)}${slideDirection(align)}`;
}, URANUS_LAYER);
export default function MobilePanelTransition(props) {
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
    transitionOnMount: true
  }));
}
MobilePanelTransition.propTypes = {
  align: PropTypes.oneOf(['bottom', 'left', 'right', 'top']).isRequired,
  duration: PropTypes.number.isRequired,
  Wrapper: PropTypes.elementType.isRequired
};
MobilePanelTransition.defaultProps = {
  align: 'right',
  duration: parseInt(PANEL_TRANSITION_TIMING, 10),
  Wrapper: MobilePanelTransitionWrapper
};
MobilePanelTransition.displayName = 'PanelTransition';